export default function PanIndiaMap() {
  return (
  <section className="pan-india-section">
    <div className="container">

        <div className="row align-items-center">

            {/* Left */}

            <div className="col-lg-6">

                <span className="section-tag">
                    🇮🇳 PAN India Network
                </span>

                <h2 className="title mt-3">
                    PAN India Network
                </h2>

                <div className="title-separator"></div>

                <p className="pan-desc">
                    Proudly serving customers across all states and union territories
                    of India through our trusted Customer, ensuring
                    timely delivery and exceptional hospitality solutions.
                </p>

                {/* <div className="row mt-4">

                    <div className="col-6 mb-4">
                        <div className="pan-card">
                            <h3>28+</h3>
                            <span>States Covered</span>
                        </div>
                    </div>

                    <div className="col-6 mb-4">
                        <div className="pan-card">
                            <h3>8</h3>
                            <span>Union Territories</span>
                        </div>
                    </div>

                    <div className="col-6">
                        <div className="pan-card">
                            <h3>100%</h3>
                            <span>Coverage</span>
                        </div>
                    </div>

                    <div className="col-6">
                        <div className="pan-card">
                            <h3>Since 1996</h3>
                            <span>Trusted Partner</span>
                        </div>
                    </div>

                </div> */}

            </div>

            {/* Right */}

            <div className="col-lg-6 text-center">

               
                    {/* <div className="india-badge">
                        PAN India
                    </div> */}

                    <img
                        src="/assets/img/india3.png"
                        className="india-map"
                        alt="India Map"
                    />

                    <div className="pulse-marker"></div>

              

            </div>

        </div>

    </div>
</section>
  );
}